import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { ConsumersService, GetEndUsersResponse } from 'src/app/core/proto';
import { actionEndUsersListGet, actionEndUsersListGetFailure, actionEndUsersListGetSuccess } from 'src/app/core/store/consumers/consumers.actions';

@Injectable({
  providedIn: 'root',
})
export class ConsumersEffects {
  constructor(
    private consumersService: ConsumersService,
    private actions$: Actions,
  ) { }

  /**
   * Get the list of consumer names
   */
  getEndUsersList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(actionEndUsersListGet),
      exhaustMap(params => {
        return this.consumersService
          .getEndUsers(params.body)
          .pipe(
            map((res: GetEndUsersResponse) => {
              return actionEndUsersListGetSuccess({
                payload: res
              });
            },
            catchError(() => of(actionEndUsersListGetFailure()))
          ));
      })
    );
  });
}
